import { BigNumber } from 'ethers'

export const ZERO = BigNumber.from(0)

export const isZero = (value?: BigNumber): boolean => {
  if (!value) return true
  return value.eq(ZERO)
}
